module.exports = {
  domain: {
    desktop: "ia.perf.use2.racing.fndlext.net",
    mobile: "ia.perf.use2.racing.fndlext.net",
    talentPicks: "ia.perf.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store.perf.use2.racing.fndlext.net"
  },
  recaptchaID: "6Lf-4hUqAAAAAGupa6W70kpZVsaFd7yaxz5pHD8r",
  recaptchaIdNative: "6Le9B1YqAAAAAJEWJZsQittPtHDcjz6xLNORgHyI"
};
